'use client';

import { ActionIcon, Group, Loader, Text } from '@mantine/core';
import { useUncontrolled } from '@mantine/hooks';
import { IconMinus, IconPlus } from '@tabler/icons-react';
import cls from './styles.module.css';

interface QuantityInputProps {
  loading?: boolean;
  value?: number;
  defaultValue?: number;
  onChange?: (value: number) => void;
}

export function QuantityInput({
  value,
  defaultValue,
  onChange,
  loading,
}: QuantityInputProps) {
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    finalValue: 1,
    onChange,
  });

  return (
    <Group className={cls.root}>
      <ActionIcon
        radius="xl"
        variant="subtle"
        onClick={() => handleChange(_value + 1)}
      >
        <IconPlus size={18} />
      </ActionIcon>

      {loading ? <Loader size="xs" /> : <Text>{_value}</Text>}

      <ActionIcon
        radius="xl"
        variant="subtle"
        onClick={() => handleChange(_value - 1 || 1)}
      >
        <IconMinus size={18} />
      </ActionIcon>
    </Group>
  );
}
